module.exports = __webpack_public_path__ + "img/member_default.2db23fa.png";